import React, { lazy, Suspense } from 'react';

const LazyPasswordResetPage = lazy(() => import('./PasswordResetPage'));

const PasswordResetPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPasswordResetPage {...props} />
  </Suspense>
);

export default PasswordResetPage;
